<template>
  <div>
    <div class="login_bg" :class="activeName == 'first' ? '' : 'vh'">
      <div class="mobile_top">
        <span @click.prevent="onTout()">欢迎来到智污邦环保服务平台 </span>
        <span class="ml-30" @click.prevent="onSet()">帮助中心</span>
        <span class="ml-30" @click.prevent="onTout()">返回首页</span>
      </div>

      <div class="mobile_middle">
        <div class="moblie_conent">
          <div class="moblie_logo" @click.prevent="onTout()">
            <img class="mt-30" src="../assets/images/logo.jpg" alt="" />
          </div>
          <div class="moblie_bater">
            <!-- <h4>找回密码</h4> -->
            <div class="mt-10">
              <el-tabs v-model="activeName" @tab-click="handleClick()">
                <!--账号找回-->
                <el-tab-pane label="账号找回" name="first">
                  <div>
                    <el-form
                      class="info_form"
                      :model="formModel"
                      :rules="accountRules"
                      ref="formModel"
                    >
                      <div v-if="show">
                          <el-form-item prop="mobile" style="width: 100%">
                            <img
                              class="icon"
                              src="../assets/images/mobile.png"
                              alt=""
                            />
                            <el-input
                              class="myClass"
                              placeholder="请输入手机号码"
                              v-model="formModel.mobile"
                              maxlength="11"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            class="code"
                            prop="imgCode"
                            style="width: 100%"
                          >
                            <img
                              class="icon"
                              src="../assets/images/security.png"
                              alt=""
                            />
                            <el-input
                              class="myClass"
                              placeholder="图形验证码"
                              v-model="formModel.imgCode"
                              maxlength="5"
                            ></el-input>
                            <img
                              class="graphic_code"
                              :src="imgUrl"
                              alt=""
                             @click.prevent="getCaptcha()"
                            />
                          </el-form-item>
                          <el-form-item
                            class="smsCode"
                            prop="smsCode"
                            style="width: 100%"
                          >
                            <el-input
                              class="myClass"
                              placeholder="短信验证码"
                              v-model="formModel.smsCode"
                              maxlength="6"
                            ></el-input>
                            <button class="shortBtn" type="button" @click="getCode">
                              {{ getCodeText }}
                            </button>
                          </el-form-item>
                          <el-form-item style="width: 100%">
                            <el-button
                              class="next"
                              @click.prevent="onNext('formModel')"
                              >下一步</el-button
                            >
                          </el-form-item>
                      </div>
                      <div v-else  class="newBox">
                         <el-form-item prop="pass">
                          <img class="icon"  src="../assets/images/password.png" alt="" />
                          <el-input
                            type="password"
                            v-model="formModel.pass"
                            placeholder="新密码"
                            autocomplete="off"
                          ></el-input>
                         </el-form-item>
                         <el-form-item prop="checkPass">
                          <img class="icon" src="../assets/images/password.png" alt="" />
                          <el-input
                            type="password"
                            placeholder="确认新密码"
                            v-model="formModel.checkPass"
                            autocomplete="off"
                          ></el-input>
                         </el-form-item>
                        <div class="mt-40">
                          <el-button class="next" @click.prevent="onReset('formModel')"
                            >确认修改</el-button
                          >
                        </div>
                      </div>
                    </el-form>
                  </div>
                </el-tab-pane>
                <!--邮箱找回-->
                <el-tab-pane label="通过邮箱找回" name="second">
                  <div>
                    <el-form :model="ruleForm" ref="ruleForm" :rules="rules">
                      <div v-if="remain">
                          <el-form-item
                        class="phone"
                        prop="email"
                        style="width: 100%"

                      >
                        <img
                          class="icon"
                          src="../assets/images/email.png"
                          alt=""
                        />
                        <el-input
                          class="myClass"
                          placeholder="请输入你的电子邮箱"
                          v-model="ruleForm.email"
                        ></el-input>
                          </el-form-item>
                          <el-form-item
                            class="code"
                            prop="smcode"
                            style="width: 100%"
                          >
                            <img
                              class="icon"
                              src="../assets/images/security.png"
                              alt=""
                            />
                            <el-input
                              class="myClass"
                              placeholder="图形验证码"
                              v-model="ruleForm.smcode"
                              maxlength="5"
                            ></el-input>
                            <img
                              class="graphic_code"
                              :src="imgUrl"
                              alt=""
                              @click.prevent="getCaptcha()"
                            />
                          </el-form-item>
                          <el-form-item style="width: 100%">
                        <el-button class="next" @click="submitForm('ruleForm')"
                          >发送邮件</el-button
                        >
                          </el-form-item>
                      </div>
                      <div v-else class="newBox">
                         <el-form-item prop="pass">
                          <img class="icon"  src="../assets/images/password.png" alt="" />
                          <el-input
                            type="password"
                            v-model="ruleForm.pass"
                            placeholder="新密码"
                            autocomplete="off"
                          ></el-input>
                         </el-form-item>
                         <el-form-item prop="checkPass">
                          <img class="icon" src="../assets/images/password.png" alt="" />
                          <el-input
                            type="password"
                            placeholder="确认新密码"
                            v-model="ruleForm.checkPass"
                            autocomplete="off"
                          ></el-input>
                         </el-form-item>
                         <div class="mt-40">
                          <el-button class="next" @click.prevent="onReset('ruleForm')"
                            >确认修改</el-button
                          >
                         </div>
                      </div>
                    </el-form>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="not fcl">
              <span>没有账号,</span>
              <span class="underline" @click="onRegister()">去注册</span>
            </div>
          </div>
        </div>
        <div class="moblie_text">
          中国·山东环境领域“互联网+环保”务实发展为本的共享平台
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  changePassword,
  authPhoneBind,
  getCode,
  getValidate,
  checkPhoneVaild,
  findPassword,
  retrievesend,
  modifypassword
} from "@/api/user";
import { getUUID } from "@/utils/index.js";
import {getToken} from '@/utils/auth';
export default {
  data(){
    //验证手机号规则
    var checkMobile = (rule, value, callback) => {
      // 验证手机号的正则表达式
      // const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      const regMobile = /^1\d{10}$/;
      if (regMobile.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的手机号"));
    };
     // 验证密码规则
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.formModel.checkPass !== '') {
            this.$refs.formModel.validateField('checkPass');
          }
          callback();
        }
    };
    var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.formModel.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
    };

    var validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
    };
    var validatePassword2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
    };
    //验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 验证邮箱的正则表达式
       const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
       if(!value){
        return callback(new Error('邮箱不能为空'))
       }
       setTimeout(() => {
          if (regEmail.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确的邮箱格式'))
          }
        }, 100)
     }
    return {
      imgUrl: "",
      formModel: {
        mobile: "",
        imgCode: "", //图形验证码
        smsCode: "", //短信验证码
        pass:'', //密码
        checkPass:''
      },
      accountRules: {
        mobile: [{
            required: true,
            validator: checkMobile,
            trigger: "blur",
          },
        ],
        imgCode: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
        smsCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      ruleForm:{
        email: "",
        smcode: "",
        pass:'', //密码
        checkPass:''
      },
      rules:{
        email:[{required:true, validator: checkEmail, trigger: 'blur' }],
        smcode: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
        pass: [{ validator: validatePassword, trigger: "blur" }],
        checkPass: [{ validator: validatePassword2, trigger: "blur" }],
      },
      activeName: "first",
      show: true,
      remain:true,
      imgUrl: "",
      uid: "",
      getCodeText: "获取验证码",
      getCodeisWaiting: false,
      url:'',
      urlObj:{},
      token:'',
      loading:true
    };
  },
  created() {
    this.getCaptcha();
    this.query();
	  this.url = window.location.href;
  },
  methods: {
    setTimer() {
      let holdTime = 60;
      this.getCodeText = "重新获取(60)";
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.getCodeisWaiting = false;
          this.getCodeText = "获取验证码";
          holdTime = 60;
          clearInterval(this.Timer);
          return;
        }
        this.getCodeText = "重新获取(" + holdTime + ")";
        holdTime--;
      }, 1000);
    },
    handleClick(tab, event) {
      if(this.activeName =='first' || this.activeName =='second'){
        this.show = true;
        this.remain = true;
      }
    },
    //帮助中心
    onSet() {
      this.$router.push("/help_center");
    },
    //注册
    onRegister() {
      this.$router.push("/register");
    },
    //下一步
    onNext(formName) {
        //修改验证短信验证码
        this.$refs[formName].validate((valid)=>{
          if(valid){
            checkPhoneVaild({
              mobile: this.formModel.mobile,
              smsCode: this.formModel.smsCode,
            }).then((res) => {
            if(res.code ==0){
                this.token = res.token;
                this.show = false;
            }
          });
          }else{
            return false;
          }
        });
    },
    //修改密码
    onReset(formName) {
       this.$refs[formName].validate((valid) => {
        if (valid){
            if(this.activeName == 'first'){  //短信找回
              findPassword({
                token:this.token,
                newPwd:this.formModel.checkPass
              }).then((res)=>{
                if(res.code ==0){
                  this.$message({
                    message: "修改成功,快去登录吧",
                    type: "success",
                    duration: 1000,
                    onClose: (res) => {
                      this.$router.push({
                        path: "/login",
                    });
                  },
                 });
                 this.show = true;
                }
              }).catch((err)=>{})
            }else{     //邮箱找回
              modifypassword({
                mail:this.urlObj.mail,
                password:this.ruleForm.pass,
                rndCode:this.urlObj.rndcode
              }).then((res)=>{
                if(res.code ==0){
                  this.$message({
                    message: "修改成功,快去登录吧",
                    type: "success",
                    duration: 1000,
                    onClose: (res) => {
                      this.$router.push({
                        path: "/login",
                      });
                  },
                 });
                 this.remain = true;
                }
              }).catch((err)=>{})
            }
            }else {
             return false;
          }
      });
    },
    //首页
    onTout() {
      this.$router.push("/");
    },
    //获取图形验证码
    getCaptcha() {
      this.uid = getUUID();
      this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
    },
    //获取短信验证码
    getCode() {
      if (!this.formModel.mobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (!this.formModel.imgCode) {
        this.$message({
          message: "请输入图形验证码",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (this.getCodeisWaiting) {
        return false;
      }
      authPhoneBind({
        mobile: this.formModel.mobile,
        uuid: this.uid,
        imgCode: this.formModel.imgCode,
      })
        .then((res) => {
          if (res.code == 0) {
            this.setTimer();
            this.getCodeisWaiting = true;
            this.$message({
              message: "验证码发送成功",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //发送邮件
    submitForm(formName){
       this.$refs[formName].validate((valid) => {
          if (valid) {
            let postData= {
              imgcode:this.ruleForm.smcode,
              sendto:this.ruleForm.email,
              uuid:this.uid
            };
            retrievesend(postData).then((res)=>{
              if(res.code ==0){
                 this.$message({
                    message:'请到您绑定的邮箱，打开链接找回',
                    type: 'success',
                    duration:1000,
                 });
                this.remain = false;
              }
            }).catch((err)=>{})
          } else {
            return false;
          }
        });
    },
    //截取参数
    query(){
      let obj = {};
      var data = decodeURIComponent(this.url).slice(decodeURIComponent(this.url).indexOf("?")+1);
      var arry = data.split("&");
      arry.forEach((item)=>{
        var arr = item.split("=");
        obj[arr[0]] = arr[1];
      });
      return obj;
      this.urlObj = obj;
    }
  },
};
</script>
<style scoped>
.login_bg {
  background: url("../assets/images/login.jpg") no-repeat center/cover;
  min-height: 100vh;
}
/* .vh {
  height: 100vh;
} */
.fcl {
  display: flex;
  justify-content: left;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-40 {
  margin-top: 40px;
}
.ml-30 {
  margin-left: 30px;
}
.mb-100 {
  margin-bottom: 100px;
}
.underline {
  cursor: pointer;
  text-decoration: underline;
}
.info_form >>> .el-input__inner {
  height: 50px;
}
.info_form>>>.el-button--default:hover{
  color: #ffffff;
}
.mobile_top {
  padding: 19px 22px;
}
.mobile_top span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.mobile_top span:hover {
  cursor: pointer;
}
.mobile_middle {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.moblie_conent {
  /* width: 536px; */
  width: 436px;
  background: #ffffff;
  /* opacity: 0.9; */
  margin-top: 60px;
}
.moblie_bater {
  margin: 32px 30px;
}
.moblie_conent h4 {
  font-size: 26px;
  font-family: PingFangSC;
  font-weight: bold;
  color: #333333;
}
.moblie_logo {
  display: flex;
  justify-content: center;
}
.moblie_bater >>> .el-tabs__nav-wrap::after {
  width: 0%;
}
.moblie_bater >>> .el-tabs__item {
  font-size: 18px;
}
.moblie_bater >>> .el-tabs__item.is-active {
  color: #333333;
  font-weight: bold;
}
.moblie_bater >>> .el-tabs__item:hover {
  color: #333333;
  font-weight: bold;
}
.moblie_bater >>> .el-tabs__active-bar {
  background-color: #333333;
}
.info_form >>> .el-form-item__content {
  margin-left: 0px !important;
}

.moblie_logo img {
  width: 189px;
  height: 59px;
  cursor: pointer;
}
.phone {
  position: relative;
}
.icon {
  width: 24px;
  height: 26px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
}
.other_type p:nth-child(1) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.other_type p:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.code {
  position: relative;
}
.graphic_code {
  position: absolute;
  right: 0;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.smsCode {
  position: relative;
}
.shortBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 125px;
  height: 50px;
  background: #e5e5e5;
  /* border: 1px solid #999999;
  opacity: 0.2; */
}
.next {
  width: 100%;
  height: 50px;
  background: linear-gradient(104deg, #a2dc14, #69cc1e);
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-top: 15px;
}
.next:hover {
  color: #ffffff;
}
.not span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.code {
  position: relative;
}
.moblie_text {
  /* width: 441px; */
  text-align: center;
  margin-top: 15px;
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
}
/deep/.myClass input.el-input__inner {
  padding-left: 50px;
  height: 50px;
  font-size: 12px;
  background: #ffffff !important;
  border: 1px solid #eeeeee;
}
.el-button {
  border: none;
}

.newBox {
  padding: 15px 0px;
  height: 300px;
}
.newBox >>> .el-input__inner {
  padding-left: 40px;
  height: 50px;
  font-size: 12px;
  background: #ffffff !important;
  border: 1px solid #eeeeee;
}
.newBox h5 {
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: bold;
  color: #333333;
  margin-top: 30px;
}
.myForm {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/retrieve.vue